import {RealtimeInterface} from '../services/realtime/realtime-interface';
import {Role} from './auth/role.class';
import {UserAssignment} from './user-assignment.class';

export class User implements RealtimeInterface {
    id?: number;
    name: string;
    email: string;
    password: string;

    hourly_rate?: number;
    assignments?: UserAssignment[];
    employment_start?: Date;
    employment_end?: Date;
    period_costs?: number;
    cur_month: number;
    prev_month: number;

    calendarUrl?: string;

    roles?: Role[];

    updated_at?: Date;
    deleted_at?: Date;
}
